import { memo, useMemo } from 'react'
import { Fade, Popper as PopperMui, SxProps } from '@mui/material'
import { Box } from '@/components/Layout'

import { popperStyles as styles } from './Popper.style'
import { PopperProps } from './Popper.types'

function Popper({
  children,
  anchorEl,
  wrapperSx = {},
  sx = {},
  parentWidth = false,
  modifiers = [],
  ...props
}: PopperProps) {
  const width = useMemo(() => {
    return anchorEl && 'getBoundingClientRect' in anchorEl
      ? anchorEl.getBoundingClientRect().width
      : undefined
  }, [anchorEl])

  return (
    <PopperMui
      anchorEl={anchorEl}
      transition
      sx={[styles.wrapper, wrapperSx] as SxProps}
      modifiers={[{ name: 'flip', enabled: false }, ...modifiers]}
      {...props}>
      {({ TransitionProps }) => (
        <Fade {...TransitionProps} timeout={350}>
          <Box
            sx={
              [
                styles.contentWrapper,
                { width: parentWidth ? width : 'auto', minWidth: width },
                sx,
              ] as SxProps
            }>
            {children}
          </Box>
        </Fade>
      )}
    </PopperMui>
  )
}

export default memo(Popper)
